export enum Service {
  Admin = 'admin',
  EmbeddedEditor = 'embedded-doc-editor',
  StandaloneEditor = 'standalone-doc-editor',
}

export enum CustomRumEvent {
  SdkVersion = 'sdk_version',
}

export type CustomRumEventData = {
  actionName: CustomRumEvent.SdkVersion;
  meta: string;
};

export enum IntentType {
  READ = 'READ',
  FILL = 'FILL',
  SIGN = 'SIGN',
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  ANNOTATE = 'ANNOTATE',
  COMPOSE = 'COMPOSE',
  SELF_SERVE = 'SELF_SERVE',
}

export const DefaultFieldRules = 'DEFAULT';

export const AllFieldPermissions = 'ALL';

export enum FieldPermission {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  POSITION = 'POSITION',
  ASSIGNMENT = 'ASSIGNMENT',
  LABEL = 'LABEL',
  APPEARANCE = 'APPEARANCE',
  HELP = 'HELP',
  CONDITION = 'CONDITION',
  VALUE = 'VALUE',
  MATERIAL = 'MATERIAL',
  LINKED_FIELDS = 'LINKED_FIELDS',
}

export enum EditorApp {
  Default = 'DEFAULT',
  SelfServe = 'SELF_SERVE',
  TemplateEditor = 'TEMPLATE_EDITOR',
  Annotation = 'ANNOTATION',
  OrganizePages = 'ORGANIZE_PAGES',
}

export enum EditorMode {
  Edit = 'EDIT',
  Read = 'READ',
  Fill = 'FILL',
}

export const FieldType = {
  Signature: 'SIGNATURE',
  Initial: 'INITIAL',
  Text: 'TEXT',
  Date: 'DATE',
  Time: 'TIME',
  DateTime: 'DATETIME',
  Radio: 'RADIO',
  Checkbox: 'CHECKBOX',
  Dropdown: 'DROPDOWN',
  Strike: 'STRIKE',
  Note: 'NOTE',
  Image: 'IMAGE',
} as const;

export type FieldType = (typeof FieldType)[keyof typeof FieldType];

const _signingFieldTypes = [FieldType.Signature, FieldType.Initial] as const;

export type SigningFieldType = (typeof _signingFieldTypes)[number];

// Exported with widened elements so membership checks accept any FieldType.
export const SIGNING_FIELD_TYPES: ReadonlyArray<FieldType> = _signingFieldTypes;

export const BOOLEAN_FIELD_TYPES: ReadonlyArray<FieldType> = [
  FieldType.Checkbox,
  FieldType.Radio,
];

export enum ReadinessInfoState {
  InProgress = 'IN_PROGRESS',
  Ready = 'READY',
  Failed = 'FAILED',
}

export const ZDOCS_REQUEST_ID_HEADER = 'x-zdocs-request-id';
